<template>
  <div class="animated fadeIn">
    <div class="row mb-10">
      <div class="col-6">
        <div v-if="$route.query.member_pha">
          <a @click="openPage('/memberPha')" class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
        </div>
        <div v-else>
          <a @click="openPage('/memberData')" class="link-back"><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
        </div>
      </div>
      <div class="col-6 text-right" v-if="id_lead">
        <a @click="openPage('/leads/ehaView?id=' + id_lead_member + '&id_lead=' + id_lead)" class="btn-primary">EHA
          Form</a>
      </div>
    </div>
    <div class="box-mini mb-30">
      <div class="p-30">
        <div class="mb-30">
          <table>
            <tr>
              <td><img class="img-circle-70 box-shadow mr-15" src="/placeholder.png" alt=""></td>
              <td>
                <h1 class="mb-0 font-400 color-secondary">{{ dataMember.first_name }} {{ dataMember.last_name }}</h1>
              </td>
            </tr>
          </table>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Membership Name</div>
              </b-col>
              <b-col sm="8">
                <div>{{ dataMember.membership_last_buy_name }}</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Email</div>
              </b-col>
              <b-col sm="8">
                <div>{{ dataMember.email }}</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">ID Card</div>
              </b-col>
              <b-col sm="8">
                <div>{{ dataMember.no_ktp ? dataMember.no_ktp : '-' }}</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Birthday</div>
              </b-col>
              <b-col sm="8">
                <div>{{ dataMember.birthday }}</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Gender</div>
              </b-col>
              <b-col sm="8">
                <div>{{ dataMember.gender && dataMember.gender.id === 1 ? 'Male' : 'Female' }}</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Phone Number</div>
              </b-col>
              <b-col sm="8">
                <div>{{ dataMember.phone_number }}</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Home Number</div>
              </b-col>
              <b-col sm="8">
                <div>{{ dataMember.home_number }}</div>
              </b-col>
            </b-row>
            <template v-if="user_role_id == 3 || user_role_id == 4 || user_role_id == 6 || user_role_id == 1 || user_role_id == 20">
              <b-row class="mb-15">
                <b-col sm="4">
                  <div class="color-secondary">Emergency Contact</div>
                </b-col>
                <b-col sm="8">
                  <div>{{ dataMember.emergency_contact }}</div>
                </b-col>
              </b-row>
              <b-row class="mb-15">
                <b-col sm="4">
                  <div class="color-secondary">Emergency Number</div>
                </b-col>
                <b-col sm="8">
                  <div>{{ dataMember.emergency_phone ? dataMember.emergency_phone : '-' }}</div>
                </b-col>
              </b-row>
              <b-row class="mb-15">
                <b-col sm="4">
                  <div class="color-secondary">Address</div>
                </b-col>
                <b-col sm="8">
                  <div>{{ dataMember.address }}</div>
                </b-col>
              </b-row>
              <b-row class="mb-15">
                <b-col sm="4">
                  <div class="color-secondary">Lead Owner</div>
                </b-col>
                <b-col sm="8">
                  <div>{{ salesName }}</div>
                </b-col>
              </b-row>
              <b-row class="mb-15">
                <b-col sm="4">
                  <div class="color-secondary">Lead Source</div>
                </b-col>
                <b-col sm="8">
                  <div>{{ dataMember.source ? dataMember.source.name : '-' }}</div>
                </b-col>
              </b-row>
              <!-- <div>
                <b-row class="mb-15">
                  <b-col sm="4">
                    <div class="color-secondary">PT Session</div>
                  </b-col>
                  <b-col sm="8">
                    <div>{{member_pha_buy_session_qty}}/{{member_pha_current_session_qty}}</div>
                  </b-col>
                </b-row>
                <b-row class="mb-15">
                  <b-col sm="4">
                    <div class="color-secondary">PT Session Expired</div>
                  </b-col>
                  <b-col sm="8">
                    <div>{{member_pha_expired_at}}</div>
                  </b-col>
                </b-row>
              </div> -->
            </template>
          </div>
          <div class="col-md-6" v-if="user_role_id == 3 || user_role_id == 4 || user_role_id == 6">
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Document Type</div>
              </b-col>
              <b-col sm="8">
                <div>{{ dataLeads.doc_name ? dataLeads.doc_name : '-' }}</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Selfie Photo</div>
              </b-col>
              <b-col sm="8">
                <div v-if="dataLeads.selfie_photo">
                  <b-btn @click="showModal('selfie_photo')" size="sm" class="btn-table green"><i
                      class="fas fa-eye mr-5"></i>View</b-btn>
                  <b-modal modal-class="modal-custom-image" hide-footer :ref="'selfie_photo'" centered
                    title="Selfie Photo">
                    <img class="w-100 img-fix" :src="parseImg(dataLeads.selfie_photo)">
                  </b-modal>
                </div>
                <div v-else>-</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">ID Card Photo</div>
              </b-col>
              <b-col sm="8">
                <div v-if="dataLeads.ktp_photo">
                  <b-btn @click="showModal('ktp_photo')" size="sm" class="btn-table green"><i
                      class="fas fa-eye mr-5"></i>View</b-btn>
                  <b-modal modal-class="modal-custom-image" hide-footer :ref="'ktp_photo'" centered
                    title="ID Card Photo">
                    <img class="w-100 img-fix" :src="parseImg(dataLeads.ktp_photo)">
                  </b-modal>
                </div>
                <div v-else>-</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Credit Card Photo</div>
              </b-col>
              <b-col sm="8">
                <div v-if="dataLeads.credit_card_photo">
                  <b-btn @click="showModal('credit_card_photo')" size="sm" class="btn-table green"><i
                      class="fas fa-eye mr-5"></i>View</b-btn>
                  <b-modal modal-class="modal-custom-image" hide-footer :ref="'credit_card_photo'" centered
                    title="Credit Card Photo">
                    <img class="w-100 img-fix" :src="parseImg(dataLeads.credit_card_photo)">
                  </b-modal>
                </div>
                <div v-else>-</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Other Selfie Photo</div>
              </b-col>
              <b-col sm="8">
                <div v-if="dataLeads.other_person_selfie_photo">
                  <b-btn @click="showModal('other_person_selfie_photo')" size="sm" class="btn-table green"><i
                      class="fas fa-eye mr-5"></i>View</b-btn>
                  <b-modal modal-class="modal-custom-image" hide-footer :ref="'other_person_selfie_photo'" centered
                    title="Other Selfie Photo">
                    <img class="w-100 img-fix" :src="parseImg(dataLeads.other_person_selfie_photo)">
                  </b-modal>
                </div>
                <div v-else>-</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Other ID Card Photo</div>
              </b-col>
              <b-col sm="8">
                <div v-if="dataLeads.other_person_ktp_photo">
                  <b-btn @click="showModal('other_person_ktp_photo')" size="sm" class="btn-table green"><i
                      class="fas fa-eye mr-5"></i>View</b-btn>
                  <b-modal modal-class="modal-custom-image" hide-footer :ref="'other_person_ktp_photo'" centered
                    title="Other ID Card Photo">
                    <img class="w-100 img-fix" :src="parseImg(dataLeads.other_person_ktp_photo)">
                  </b-modal>
                </div>
                <div v-else>-</div>
              </b-col>
            </b-row>
            <b-row class="mb-15">
              <b-col sm="4">
                <div class="color-secondary">Other Credit Card Photo</div>
              </b-col>
              <b-col sm="8">
                <div v-if="dataLeads.other_person_credit_card_photo">
                  <b-btn @click="showModal('other_person_credit_card_photo')" size="sm" class="btn-table green"><i
                      class="fas fa-eye mr-5"></i>View</b-btn>
                  <b-modal modal-class="modal-custom-image" hide-footer :ref="'other_person_credit_card_photo'" centered
                    title="Other Credit Card Photo">
                    <img class="w-100 img-fix" :src="parseImg(dataLeads.other_person_credit_card_photo)">
                  </b-modal>
                </div>
                <div v-else>-</div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-20">
      <div class="row">
        <div class="col-sm-6">
          <div class="font-bold mb-10">Parameter Health Analysis</div>
        </div>
        <div class="col-sm-6 text-right">
          <a @click="openPage('/memberData/phaForm?member=' + dataMember.id)" class="font-bold color-primary mb-10">+
            Add
            New</a>
        </div>
      </div>
      <div class="box-mini">
        <div class="p-15">
          <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm"
            :items="dataPha" :fields="phaFields">
            <template v-slot:cell(created_at)="data">
              <!--            <template slot="created_at" slot-scope="data">-->
              {{ data.item.created_at | moment('DD/MM/YYYY') }}
            </template>
            <template v-slot:cell(action)="data">
              <!--            <template slot="action" slot-scope="data">-->
              <b-button size="sm"
                @click="openPage('/memberData/phaForm?member=' + id_lead_member + '&id=' + data.item.id + '&id_lead=' + $route.query.id_lead)"
                class="btn-table primary mr-5 mb-5">
                <i class="far fa-edit"></i> Edit
              </b-button>
              <b-button size="sm" :name="'download' + data.item.id" :ref="'download' + data.item.id"
                @click="downloadPHA(data.item.id, data.item.created_at)" class="btn-table green mb-5">
                <span :ref="'iconDownload' + data.item.id"><i class="fas fa-download"></i> Download</span>
                <span :ref="'spinnerDownload' + data.item.id" class="hidden"><b-spinner small></b-spinner>
                  Download</span>
              </b-button>
              <!-- <b-button size="sm" @click="downloadPHA(data.item.id, data.item.created_at)" class="btn-table green mb-5">
                <i class="fas fa-download"></i> Download
              </b-button> -->
              <a id="downloadAnchorElem" style="display:none"></a>
            </template>
          </b-table>
          <app-pagination class="pagination-custom mt-20" :current-page="phaCurrentPage" :total-pages="phaTotalPage"
            @page-changed="phaPageOneChanged" prev-text="Prev" next-text="Next" />
        </div>
      </div>
    </div>
    <div class="mb-20">
      <div class="row">
        <div class="col-sm-6">
          <div class="font-bold mb-10">Member Diary</div>
        </div>
        <div class="col-sm-6 text-right">
          <a @click="openPage('/memberData/addMemberDiary?id=' + id_lead_member + '&id_lead=' + id_lead)"
            class="font-bold color-primary mb-10">+ Add Member Diary</a>
        </div>
      </div>
      <div class="box-mini">
        <div class="p-15">
          <b-table :busy="isLoadingMemberDiary" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
            :fixed="fixed" responsive="sm" :items="itemMemberDiary" :fields="fieldDiary">
            <!--            <template slot="action" slot-scope="data">-->
            <template v-slot:cell(action)="data">
              <b-button size="sm"
                @click="openPage('/memberData/listMemberDiary?id=' + id_lead_member + '&id_lead=' + id_lead + '&date=' + data.item.schedule_date)"
                class="btn-table green mb-5">
                <i class="far fa-eye"></i> Detail
              </b-button>
              <!-- <b-button style="margin-left: 20px" size="sm" @click="dupicateMemberDiary(data.item)" class="btn-table primary mb-5">
                <i class="far fa-clone"></i> Duplicate
              </b-button> -->
              <b-button style="margin-left: 20px" size="sm" @click="showModalDuplicate('modalChangePass', data.item)"
                class="btn-table primary mb-5">
                <i class="far fa-clone"></i> Duplicate
              </b-button>

              <b-button style="margin-left: 20px" size="sm" @click="deleteMemberDiary(data.item)"
                class="btn-table danger mb-5">
                <i class="fas fa-times"></i> Delete
              </b-button>
            </template>
          </b-table>
          <app-pagination class="pagination-custom mt-20" :current-page="currentPageMemberDiary"
            :total-pages="totalMemberDiary" @page-changed="pageMemberDiayChanged" prev-text="Prev" next-text="Next" />
        </div>
      </div>
    </div>
    <!-- First Assesment -->
    <div class="mb-20">
      <div class="row">
        <div class="col-sm-6">
          <div class="font-bold mb-10">First Assesment</div>
        </div>
        <div class="col-sm-6 text-right">
          <!-- <a @click="openPage('/memberData/addFirstAssessment?id=' + id_lead_member + '&id_lead=' + id_lead)"
            class="font-bold color-primary mb-10">+ Add</a> -->
          <a @click="showModal('add-assessment')" class="font-bold color-primary mb-10">+ Add</a>
        </div>
      </div>
      <div class="box-mini">
        <div class="p-15">
          <b-table :busy="isLoadingMemberDiary" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
            :fixed="fixed" responsive="sm" :items="itemFirstAssessment" :fields="fieldsFirstAssessment">
            <!--            <template slot="action" slot-scope="data">-->
            <template v-slot:cell(action)="data">
              <b-button size="sm"
                @click="openPage('/memberData/addFirstAssessment?id=' + id_lead_member + '&id_lead=' + id_lead + '&xid=' + data.item.id + '&mode=edit')"
                class="btn-table green mb-5">
                <i class="far fa-eye"></i> Detail
              </b-button>
              <!-- <b-button style="margin-left: 20px" size="sm" @click="dupicateMemberDiary(data.item)" class="btn-table primary mb-5">
                <i class="far fa-clone"></i> Duplicate
              </b-button> -->
              <!-- <b-button style="margin-left: 20px" size="sm" @click="showModalDuplicate('modalChangePass', data.item)"
                class="btn-table primary mb-5">
                <i class="far fa-clone"></i> Duplicate
              </b-button> -->

              <b-button style="margin-left: 20px" size="sm" @click="deleteFirstAssessment(data.item.id)"
                class="btn-table danger mb-5">
                <i class="fas fa-times"></i> Delete
              </b-button>
            </template>
          </b-table>
          <app-pagination class="pagination-custom mt-20" :current-page="firstAssessmentCurrentPage"
            :total-pages="firstAssessmentTotalPage" @page-changed="pageFirstAssessmentChanged" prev-text="Prev"
            next-text="Next" />
        </div>
      </div>
    </div>
    <!-- End First Assesment -->

    <!-- Weekly Log Assesment -->
    <div class="mb-20">
      <div class="row">
        <div class="col-sm-6">
          <div class="font-bold mb-10">Weekly Log</div>
        </div>
        <div class="col-sm-6 text-right">
          <!-- <a @click="openPage('/memberData/addFirstAssessment?id=' + id_lead_member + '&id_lead=' + id_lead)"
            class="font-bold color-primary mb-10">+ Add</a> -->
          <a @click="showModal('add-weekly-log')" class="font-bold color-primary mb-10">+ Add</a>
        </div>
      </div>
      <div class="box-mini">
        <div class="p-15">
          <b-table :busy="isLoadingMemberDiary" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
            :fixed="fixed" responsive="sm" :items="itemWeeklyLogAssessment" :fields="fieldsWeeklyLogAssessment">
            <!--            <template slot="action" slot-scope="data">-->
            <template v-slot:cell(action)="data">
              <b-button size="sm"
                @click="openPage('/memberData/addWeeklyLogAssessment?id=' + id_lead_member + '&id_lead=' + id_lead + '&xid=' + data.item.id + '&mode=edit')"
                class="btn-table green mb-5">
                <i class="far fa-eye"></i> Detail
              </b-button>
              <!-- <b-button style="margin-left: 20px" size="sm" @click="dupicateMemberDiary(data.item)" class="btn-table primary mb-5">
                <i class="far fa-clone"></i> Duplicate
              </b-button> -->
              <!-- <b-button style="margin-left: 20px" size="sm" @click="showModalDuplicate('modalChangePass', data.item)"
                class="btn-table primary mb-5">
                <i class="far fa-clone"></i> Duplicate
              </b-button> -->

              <b-button style="margin-left: 20px" size="sm" @click="deleteWeeklyLogAssessment(data.item.id)"
                class="btn-table danger mb-5">
                <i class="fas fa-times"></i> Delete
              </b-button>
            </template>
          </b-table>
          <app-pagination class="pagination-custom mt-20" :current-page="weeklyLogAssessmentCurrentPage"
            :total-pages="weeklyLogAssessmentTotalPage" @page-changed="pageWeeklyLogAssessmentChanged" prev-text="Prev"
            next-text="Next" />
        </div>
      </div>
    </div>
    <!-- End Weekly Log -->

    <!-- Two To Four Checking -->
    <div class="mb-20">
      <div class="row">
        <div class="col-sm-6">
          <div class="font-bold mb-10">2 to 4 Weeks Checking</div>
        </div>
        <div class="col-sm-6 text-right">
          <!-- <a @click="openPage('/memberData/addFirstAssessment?id=' + id_lead_member + '&id_lead=' + id_lead)"
            class="font-bold color-primary mb-10">+ Add</a> -->
          <a @click="showModal('add-checking')" class="font-bold color-primary mb-10">+ Add</a>
        </div>
      </div>
      <div class="box-mini">
        <div class="p-15">
          <b-table :busy="isLoadingMemberDiary" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
            :fixed="fixed" responsive="sm" :items="itemTwoto4weekcheckingAssessment"
            :fields="fieldsTwoto4weekcheckingAssessment">
            <!--            <template slot="action" slot-scope="data">-->
            <template v-slot:cell(action)="data">
              <b-button size="sm"
                @click="openPage('/memberData/add2to4weeksChecking?id=' + id_lead_member + '&id_lead=' + id_lead + '&xid=' + data.item.id + '&mode=edit')"
                class="btn-table green mb-5">
                <i class="far fa-eye"></i> Detail
              </b-button>
              <!-- <b-button style="margin-left: 20px" size="sm" @click="dupicateMemberDiary(data.item)" class="btn-table primary mb-5">
                <i class="far fa-clone"></i> Duplicate
              </b-button> -->
              <!-- <b-button style="margin-left: 20px" size="sm" @click="showModalDuplicate('modalChangePass', data.item)"
                class="btn-table primary mb-5">
                <i class="far fa-clone"></i> Duplicate
              </b-button> -->

              <b-button style="margin-left: 20px" size="sm" @click="delete2to4WeekCheckingAssessment(data.item.id)"
                class="btn-table danger mb-5">
                <i class="fas fa-times"></i> Delete
              </b-button>
            </template>
          </b-table>
          <app-pagination class="pagination-custom mt-20" :current-page="twoto4weekcheckingAssessmentCurrentPage"
            :total-pages="twoto4weekcheckingAssessmentTotalPage" @page-changed="pageTwoToFourCheckingAssessmentChanged"
            prev-text="Prev" next-text="Next" />
        </div>
      </div>
    </div>
    <!-- End Weekly Log -->

    <div class="mb-20" v-if="id_lead">
      <div class="row">
        <div class="col-sm-6">
          <div class="font-bold mb-10">Activities</div>
        </div>
        <div class="col-sm-6 text-right">
          <template v-if="!(items.length === 0)">
            <template v-if="validateInterested === 'Interested'">
              <a @click="showModal('new-appointment')" class="font-bold color-primary mb-10 mr-15">+ Appointment</a>
            </template>
          </template>
          <a @click="showModal('new-call')" class="font-bold color-primary mb-10">+ Call</a>
        </div>
      </div>
      <div class="box-mini">
        <div class="p-15">
          <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm"
            :items="items" :fields="fields">
            <template v-slot:cell(start_time)="data">
              <!--            <template slot="start_time" slot-scope="data">-->
              {{ cutTime(data.item.start_time) }}
            </template>
            <template v-slot:cell(due_date)="data">
              <!--            <template slot="due_date" slot-scope="data">-->
              {{ parseDateTime(data.item.due_date) }}
            </template>
            <template v-slot:cell(updated_at)="data">
              <!--            <template slot="updated_at" slot-scope="data">-->
              {{ parseDateTime(data.item.updated_at) }}
            </template>
            <template v-slot:cell(status)="data">
              <!--            <template slot="status" slot-scope="data">-->
              <b-badge :variant="getBadge(data.item.status)">{{ data.item.status }}</b-badge>
            </template>
            <!--            <template slot="activities_status" slot-scope="data">-->
            <template v-slot:cell(activities_status)="data">
              <template v-if="data.item.leads_activities_status.name == 'Verified'">
                <span v-if="(data.item.appointment_status == 'show')">Show</span>
                <span v-if="(data.item.appointment_status == 'notShow')">Not Show</span>
                <span v-if="(data.item.appointment_show_status == 'missedGuest')">
                  <i class="far fa-arrow-alt-circle-right mr-5 ml-5"></i>Missed Guest
                </span>
                <span v-if="(data.item.appointment_show_status == 'member')">
                  <i class="far fa-arrow-alt-circle-right mr-5 ml-5"></i>Member
                </span>
                <span v-if="(data.item.appointment_missed_guest_status == 'guestPassIssued')">
                  <i class="far fa-arrow-alt-circle-right mr-5 ml-5"></i>Guest Pass Issued
                </span>
                <span v-if="(data.item.appointment_missed_guest_status == 'noGuestPassIssued')">
                  <i class="far fa-arrow-alt-circle-right mr-5 ml-5"></i>No Guest Pass Issued
                </span>
              </template>
              <template v-else>
                -
              </template>
            </template>
          </b-table>
          <app-pagination class="pagination-custom mt-20" :current-page="currentPage2" :total-pages="totalPage2"
            @page-changed="pageOneChanged2" prev-text="Prev" next-text="Next" />
        </div>
      </div>
    </div>
    <b-modal modal-class="modal-custom-image" hide-footer centered :ref="'modalChangePass'" title="Select Date">
      <div class="p-10">
        <form @submit.prevent="dupicateMemberDiary(duplicateSeletedRow)">
          <div class="mb-10">
            <input type="date" class="form-control" name="event_date" min="2000-01-01" v-model="dateTodayData"
              @change="changeDate">
          </div>
          <div class="text-right">
            <button type="submit" class="btn-primary">Save</button>
          </div>
        </form>
      </div>
    </b-modal>


    <!-- call section -->
    <b-modal modal-class="modal-custom-input" hide-footer :ref="'new-call'" centered title="Create Fresh Call">
      <div class="box-shadow p-15">
        <div class="font-500">Activity Information</div>
        <hr class="short-line left mb-15" />
        <form @submit.prevent="validateCall('activityNewCall')" data-vv-scope="activityNewCall">
          <div class="mb-10">
            <div class="font-13 mb-5">Date of Call</div>
            <flat-pickr :config="config" disabled v-model="addCall.due_date" class="w-100"></flat-pickr>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Activity Type</div>
            <b-form-select name="leads_activity_type" v-validate="'required'" v-model="addCall.leads_activity_type_id"
              class="form-control">
              <option value="null">Please select</option>
              <template v-for="item in data1">
                <option :key="item.id" :value="item.id" v-if="!(item.id == '4')">{{ item.name }}</option>
              </template>
            </b-form-select>
            <span class="error">{{ errors.first('activityNewCall.leads_activity_type') }}</span>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Status</div>
            <b-form-select name="leads_activity_status" v-model="addCall.leads_activity_status_id" class="form-control">
              <option value="null">Please select</option>
              <option v-for="item in data2" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Notes</div>
            <b-form-input class="form-control" v-model="addCall.notes" name="notes" type="text"></b-form-input>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Call Time</div>
            <div class="select-time">
              <flat-pickr :config="config2" v-model="addCall.start_time" name="time_start" class="w-100"></flat-pickr>
            </div>
          </div>
          <hr class="transparent" />
          <div class="text-center">
            <button type="submit" class="btn-primary mr-10" ref="newCall">
              <span ref="submitNewCall">Submit</span>
              <span ref="spinnerNewCall" class="hidden">
                <b-spinner small></b-spinner>Submit
              </span>
            </button>
            <a @click="hideModal('new-call')" class="btn-border-primary">Close</a>
          </div>
        </form>
      </div>
    </b-modal>
    <b-modal modal-class="modal-custom-input" hide-footer :ref="'edit-call'" centered title="Edit Call">
      <div class="box-shadow p-15">
        <div class="font-500">Activity Information</div>
        <hr class="short-line left mb-15" />
        <form @submit.prevent="validateCallEdit('activityEditCall')" data-vv-scope="activityEditCall">
          <div class="mb-10">
            <div class="font-13 mb-5">Date of Call</div>
            <flat-pickr :config="config" disabled v-model="editCall.due_date" class="w-100"></flat-pickr>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Activity Type</div>
            <b-form-select name="leads_activity_type" v-validate="'required'" v-model="editCall.leads_activity_type_id"
              class="form-control">
              <option value="null">Please select</option>
              <option v-for="item in data1" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
            <span class="error">{{ errors.first('activityEditCall.leads_activity_type') }}</span>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Status</div>
            <b-form-select name="leads_activity_type" v-model="editCall.leads_activity_status_id" class="form-control">
              <option value="null">Please select</option>
              <option v-for="item in data2" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Notes</div>
            <b-form-input class="form-control" v-model="editCall.notes" name="notes" type="text"></b-form-input>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Call Time</div>
            <div class="select-time">
              <flat-pickr :config="config2" v-model="editCall.start_time" name="time_start" class="w-100"></flat-pickr>
            </div>
          </div>
          <hr class="transparent" />
          <div class="text-center">
            <button type="submit" class="btn-primary mr-10" ref="editCall">
              <span ref="submitEditCall">Submit</span>
              <span ref="spinnerEditCall" class="hidden">
                <b-spinner small></b-spinner>Submit
              </span>
            </button>
            <a @click="hideModal('edit-call')" class="btn-border-primary">Close</a>
          </div>
        </form>
      </div>
    </b-modal>
    <!-- End Call -->

    <!-- appointment section -->
    <b-modal modal-class="modal-custom-input" hide-footer :ref="'new-appointment'" centered title="Create Appointment">
      <div class="box-shadow p-15">
        <div class="font-500">Activity Information</div>
        <hr class="short-line left mb-15" />
        <form @submit.prevent="validateAppointment('activityAppointment')" data-vv-scope="activityAppointment">
          <div class="mb-10">
            <div class="font-13 mb-5">Activity Type</div>
            <b-form-select name="leads_activity_type" v-model="addAppointment.leads_activity_type_id" disabled
              class="form-control bg-transparent">
              <option value="null">Please select</option>
              <option v-for="item in data1" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Status</div>
            <b-form-select name="leads_activity_type" v-model="addAppointment.leads_activity_status_id"
              class="form-control">
              <option value="null">Please select</option>
              <option v-for="item in data3" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
          <template v-if="addAppointment.leads_activity_status_id === 4">
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Status</div>
              <b-form-select v-model="addAppointment.appointment_status" class="form-control">
                <option value="null">Please select</option>
                <option value="show">Show</option>
                <option value="notShow">Not Show</option>
              </b-form-select>
            </div>
          </template>
          <template v-if="addAppointment.appointment_status === 'show'">
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Show Status</div>
              <b-form-select v-model="addAppointment.appointment_show_status" class="form-control">
                <option value="null">Please select</option>
                <option value="member">Member</option>
                <option value="missedGuest">Missed Guest</option>
              </b-form-select>
            </div>
          </template>
          <template v-if="addAppointment.appointment_show_status === 'missedGuest'">
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Missed Guest Status</div>
              <b-form-select v-model="addAppointment.appointment_missed_guest_status" class="form-control">
                <option value="null">Please select</option>
                <option value="guestPassIssued">Guest Pass Issued</option>
                <option value="noGuestPassIssued">No Guest Pass Issued</option>
              </b-form-select>
            </div>
          </template>
          <div class="mb-10">
            <div class="font-13 mb-5">Notes</div>
            <b-form-input class="form-control" v-model="addAppointment.notes" name="notes" type="text"></b-form-input>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Appointment Time</div>
            <div class="select-time">
              <flat-pickr :config="config2" v-model="addAppointment.start_time" name="time_start"
                class="w-100"></flat-pickr>
            </div>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Appointment Date</div>
            <flat-pickr :config="config" v-model="addAppointment.due_date" class="w-100"></flat-pickr>
          </div>
          <hr class="transparent" />
          <div class="text-center">
            <button type="submit" class="btn-primary mr-10" ref="newAppointment">
              <span ref="submitNewAppointment">Submit</span>
              <span ref="spinnerNewAppointment" class="hidden">
                <b-spinner small></b-spinner>Submit
              </span>
            </button>
            <a @click="hideModal('new-appointment')" class="btn-border-primary">Close</a>
          </div>
        </form>
      </div>
    </b-modal>
    <b-modal modal-class="modal-custom-input" hide-footer :ref="'edit-appointment'" centered title="Edit Appointment">
      <div class="box-shadow p-15">
        <div class="font-500">Activity Information</div>
        <hr class="short-line left mb-15" />
        <form @submit.prevent="validateAppointmentEdit('activityEditAppointment')"
          data-vv-scope="activityEditAppointment">
          <div class="mb-10">
            <div class="font-13 mb-5">Activity Type</div>
            <b-form-select name="leads_activity_type" v-model="editAppointment.leads_activity_type_id" disabled
              class="form-control bg-transparent">
              <option value="null">Please select</option>
              <option v-for="item in data1" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Status</div>
            <b-form-select name="leads_activity_type" v-model="editAppointment.leads_activity_status_id"
              class="form-control">
              <option value="null">Please select</option>
              <option v-for="item in data3" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
          </div>
          <template v-if="editAppointment.leads_activity_status_id === 4">
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Status</div>
              <b-form-select v-model="editAppointment.appointment_status" class="form-control">
                <option value="null">Please select</option>
                <option value="show">Show</option>
                <option value="notShow">Not Show</option>
              </b-form-select>
            </div>
          </template>
          <template v-if="editAppointment.appointment_status === 'show'">
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Show Status</div>
              <b-form-select v-model="editAppointment.appointment_show_status" class="form-control">
                <option value="null">Please select</option>
                <option value="member">Member</option>
                <option value="missedGuest">Missed Guest</option>
              </b-form-select>
            </div>
          </template>
          <template v-if="editAppointment.appointment_show_status === 'missedGuest'">
            <div class="mb-10">
              <div class="font-13 mb-5">Appointment Missed Guest Status</div>
              <b-form-select v-model="editAppointment.appointment_missed_guest_status" class="form-control">
                <option value="null">Please select</option>
                <option value="guestPassIssued">Guest Pass Issued</option>
                <option value="noGuestPassIssued">No Guest Pass Issued</option>
              </b-form-select>
            </div>
          </template>
          <div class="mb-10">
            <div class="font-13 mb-5">Notes</div>
            <b-form-input class="form-control" v-model="editAppointment.notes" name="notes" type="text"></b-form-input>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Appointment Time</div>
            <div class="select-time">
              <flat-pickr :config="config2" v-model="editAppointment.start_time" name="time_start"
                class="w-100"></flat-pickr>
            </div>
          </div>
          <div class="mb-10">
            <div class="font-13 mb-5">Appointment Date</div>
            <flat-pickr :config="config" v-model="editAppointment.due_date" class="w-100"></flat-pickr>
          </div>
          <hr class="transparent" />
          <div class="text-center">
            <button type="submit" class="btn-primary mr-10" ref="editAppointment">
              <span ref="submitEditAppointment">Submit</span>
              <span ref="spinnerEditAppointment" class="hidden">
                <b-spinner small></b-spinner>Submit
              </span>
            </button>
            <a @click="hideModal('edit-appointment')" class="btn-border-primary">Close</a>
          </div>
        </form>
      </div>
    </b-modal>
    <!-- End Modal Appointment -->

    <!-- Member PT Session -->
    <div class="title font-300 font-20 mb-15">Member PT Session</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData4)" v-model="searchData4" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged5" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items5" :fields="fields5" :current-page="currentPage5">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn disabled
              @click="openPage('/memberEntry/editPtSession?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm" class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
            <b-btn disabled
              @click="openPage('/memberEntry/addPtSession?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm" class="btn-table green ml-5">
              <i class="fas fa-plus-square mr-5"></i>Add
            </b-btn>
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
              }}</template>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage5" :total-pages="totalPage5"
          @page-changed="pageOneChanged5" prev-text="Prev" next-text="Next" />
      </div>
    </div>
    <!-- End Member PT Session -->

    <!-- Booking History -->
    <div class="title font-300 font-20 mb-15">Booking History</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData3)" v-model="searchData3" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged3" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="items3" :fields="fields3" :current-page="currentPage3">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/editBooking?id=' + data.item.id + '&member_id=' + $route.query.id)"
              size="sm" class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
              }}</template>
          </template>
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage3" :total-pages="totalPage3"
          @page-changed="pageOneChanged3" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <!-- Gym Attendance -->
    <div class="title font-300 font-20 mb-15">Gym Attendance</div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-5 offset-md-7 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control"
                    placeholder="Search" />
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0" />
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChangedGym" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" responsive="sm" :items="itemsGym" :fields="fieldsGym" :current-page="currentPageGym">
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->
            <b-btn v-if="getRoleId != '33' && !isViewOnly"
              @click="openPage('/memberEntry/editGym?id=' + data.item.id + '&member_id=' + $route.query.id)" size="sm"
              class="btn-table warning">
              <i class="fas fa-pen mr-5"></i>Edit
            </b-btn>
            <b-btn v-if="getRoleId != '33' && !isViewOnly" size="sm" v-on:click="deleteGymAttendance(data.item.id)"
              class="btn-table danger ml-5">
              <i class="fas fa-trash"></i> Delete
            </b-btn>
          </template>
          <template v-slot:cell(name)="data">
            <!--          <template slot="name" slot-scope="data">-->
            <template v-if="data.item.member">{{ data.item.member.first_name }} {{ data.item.member.last_name
            }}</template>
          </template>
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPageGym" :total-pages="totalPageGym"
          @page-changed="pageGymChanged" prev-text="Prev" next-text="Next" />
      </div>
    </div>

    <!-- Notes History -->
    <div class="title font-300 font-20 mb-15">Notes History</div>
    <div class="box">
      <div class="p-15">
        <b-table @sort-changed="sortingChanged6" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
          :fixed="fixed" :responsive="true" :items="items6" :fields="fields6" :current-page="currentPage6">
          <template v-slot:cell(created_at)="data">
            <!--          <template slot="created_at" slot-scope="data">-->
            {{ parseDate(data.item.created_at) }}
          </template>
          <template v-slot:cell(action)="data">
            <!--          <template slot="action" slot-scope="data">-->

            <template v-if="getRoleId == '17' || getRoleId == 17">
              <b-btn @click="updateNotes(data.item.id)" size="sm" class="btn-table warning">
                <i class="fas fa-pen mr-5"></i>Edit
              </b-btn>
            </template>
            <template v-if="getRoleId == '17' || getRoleId == 17">
              <b-btn size="sm" v-on:click="deleteNote(data.item.id)" class="btn-table danger ml-5">
                <i class="fas fa-trash"></i> Delete
              </b-btn>
            </template>

            <!-- only staff -->
            <template v-if="permissionActionNotes()">
              <b-btn @click="updateNotes(data.item.id)" size="sm" class="btn-table warning">
                <i class="fas fa-pen mr-5"></i>Edit
              </b-btn>
            </template>
            <template v-if="permissionActionNotes()">
              <b-btn size="sm" v-on:click="deleteNote(data.item.id)" class="btn-table danger ml-5">
                <i class="fas fa-trash"></i> Delete
              </b-btn>
            </template>

          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage6" :total-pages="totalPage6"
          @page-changed="pageOneChanged6" prev-text="Prev" next-text="Next" />
      </div>
      <b-modal modal-class="modal-custom-image" hide-footer ref="editNotes" centered title="Edit Notes">
        <div class="p-15">
          <!--          <form @submit.prevent="submitUpdateNotes('editNotesPart')" data-vv-scope="editNotesPart">-->
          <form v-on:submit.prevent data-vv-scope="editNotesPart">
            <div class="mb-15">
              <label>Date</label>
              <div class="select-time">
                <flat-pickr :config="configDate" v-model="editNotesData.created_at" name="editDateNotes"
                  class="w-100"></flat-pickr>
              </div>
              <span class="error">{{ errors.first('editDateNotes') }}</span>
            </div>
            <div class="mb-15">
              <label>Notes</label>
              <textarea name="editNotes" v-validate="'required'" v-model="editNotesData.notes" class="w-100"
                rows="4"></textarea>
              <span class="error">{{ errors.first('editNotesPart.editNotes') }}</span>
            </div>
            <div class="text-right">
              <button v-if="getRoleId != '33' && !isViewOnly" type="button" class="btn-primary"
                @click="submitUpdateNotes('editNotesPart')">Submit</button>
            </div>
          </form>
        </div>
      </b-modal>
    </div>


    <!-- Modal Add First Assesment -->
    <b-modal modal-class="modal-custom-input" hide-footer :ref="'add-assessment'" centered title="Add First Assesment">
      <div class="p-15">
        <hr class="short-line left mb-15" />
        <form @submit.prevent="onSubmitFirstAssessment('activityEditAppointment')"
          data-vv-scope="activityEditAppointment">
          <div class="mb-10">
            <div class="font-13 mb-5">Personal Trainer</div>
            <b-form-select v-validate="'required'" name="personal_trainer" v-model="assessment_personal_trainer_id"
              class="form-control border-bottom">
              <option :value="null" selected>Please select</option>
              <option v-for="(item, index) in dataPT" :key="index" :value="item.id">
                {{ item.name }}
              </option>
            </b-form-select>
          </div>
          <hr class="transparent" />
          <div class="text-center">
            <button type="submit" class="btn-primary mr-10" ref="editAppointment">
              <span ref="submitEditAppointment">Submit</span>
              <span ref="spinnerEditAppointment" class="hidden">
                <b-spinner small></b-spinner>Submit
              </span>
            </button>
            <a @click="hideModal('add-assessment')" class="btn-border-primary">Close</a>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- Modal Add Weekly Log -->
    <b-modal modal-class="modal-custom-input" hide-footer :ref="'add-weekly-log'" centered title="Add Weekly Log">
      <div class="p-15">
        <hr class="short-line left mb-15" />
        <form @submit.prevent="onSubmitWeeklyLogAssessement('activityEditAppointment')"
          data-vv-scope="activityEditAppointment">
          <div class="mb-10">
            <div class="font-13 mb-5">Personal Trainer</div>
            <b-form-select v-validate="'required'" name="personal_trainer" v-model="weekly_log_personal_trainer_id"
              class="form-control border-bottom">
              <option :value="null" selected>Please select</option>
              <option v-for="(item, index) in dataPT" :key="index" :value="item.id">
                {{ item.name }}
              </option>
            </b-form-select>
          </div>
          <hr class="transparent" />
          <div class="text-center">
            <button type="submit" class="btn-primary mr-10" ref="editAppointment">
              <span ref="submitEditAppointment">Submit</span>
              <span ref="spinnerEditAppointment" class="hidden">
                <b-spinner small></b-spinner>Submit
              </span>
            </button>
            <a @click="hideModal('add-assessment')" class="btn-border-primary">Close</a>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- Modal Add Checking -->
    <b-modal modal-class="modal-custom-input" hide-footer :ref="'add-checking'" centered
      title="Add 2 to 4 Week Checking">
      <div class="p-15">
        <hr class="short-line left mb-15" />
        <form @submit.prevent="onSubmitTwoFourCheckingAssessement('add-checking')"
          data-vv-scope="activityEditAppointment">
          <div class="mb-10">
            <div class="font-13 mb-5">Personal Trainer</div>
            <b-form-select v-validate="'required'" name="personal_trainer"
              v-model="twoto4weekchecking_personal_trainer_id" class="form-control border-bottom">
              <option :value="null" selected>Please select</option>
              <option v-for="(item, index) in dataPT" :key="index" :value="item.id">
                {{ item.name }}
              </option>
            </b-form-select>
          </div>
          <hr class="transparent" />
          <div class="text-center">
            <button type="submit" class="btn-primary mr-10" ref="editAppointment">
              <span ref="submitEditAppointment">Submit</span>
              <span ref="spinnerEditAppointment" class="hidden">
                <b-spinner small></b-spinner>Submit
              </span>
            </button>
            <a @click="hideModal('add-checking')" class="btn-border-primary">Close</a>
          </div>
        </form>
      </div>
    </b-modal>

    <!-- loading -->
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="">
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>

  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import moment from 'moment'
import Pagination from '@/views/component/pagination'

export default {
  name: 'leads',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      isViewOnly: false,
      getRoleId: Auth.Session.get().paradigm_role,
      loadingActive: false,
      currentPageGym: 1,
      searchDataGym: "",
      sortByGym: "",
      sortTypeGym: "",
      totalPageGym: 0,
      searchData: "",
      itemsGym: [],
      fieldsGym: [
        {
          key: "name",
          label: "Name",
          sortable: true
        },
        {
          key: "member.email",
          label: "Email",
          sortable: true
        },
        {
          key: "member.phone_number",
          label: "Phone Number",
          sortable: true
        },
        {
          key: "attendance_type.name",
          label: "Attendance Type",
          sortable: true
        },
        {
          key: "branch.name",
          label: "Club",
          sortable: true
        },
        {
          key: "join_date",
          label: "Join Date",
          sortable: false,
          formatter: (value, key, item) => {
            return moment(item.member.created_at).format("dddd, DD MMMM YYYY");
          },
        },
        {
          key: "created_at",
          label: "Attendance",
          sortable: true
        },
        // {
        //   key: "action",
        //   label: "Action",
        //   sortable: false
        // }
      ],
      items5: [],
      items3: [],
      fields3: [
        {
          key: "name",
          label: "Name",
          sortable: false
        },
        {
          key: "advisor",
          label: "Advisor",
          sortable: false,
          formatter: (value, key, item) => {
            return item.member.sales.fullname
          }
        },
        {
          key: "classes_schedule.class.name",
          label: "Class Name",
          sortable: false,
          formatter: (value, key, item) => {
            if (item.pt_planner != null) {
              if (item.pt_planner.pt_planner_activity_id == 2) {
                return item.classes_schedule.class.name.replace("Session with", "PHA Appointment with")
              } else {
                return item.classes_schedule.class.name
              }
            } else {
              return item.classes_schedule ? item.classes_schedule.class.name : '-'
            }
          }
        },
        {
          key: "class_date",
          label: "Class Date",
          formatter: (value, key, item) => {
            return moment(item.class_date).format("dddd, DD MMMM YYYY");
          },
          sortable: false
        },
        {
          key: "time_class",
          label: "Class Time",
          formatter: (value, key, item) => {
            return item.classes_schedule && item.classes_schedule.classes_time
              ? item.classes_schedule.classes_time.time_start.slice(0, -3) +
              " - " +
              item.classes_schedule.classes_time.time_end.slice(0, -3)
              : "";
          },
          sortable: false
        },
        {
          key: "classes_schedule.studio.name",
          label: "Studio",
          sortable: true
        },
        // {
        //   key: "action",
        //   label: "Action",
        //   sortable: false
        // }
      ],
      currentPage3: 1,
      totalPage3: 0,
      paginationLimit3: 10,
      sortBy3: "",
      sortType3: "",
      searchData3: "",
      currentPage5: 1,
      paginationLimit5: 10,
      searchData4: "",
      sortBy5: "",
      sortType5: "",
      totalPage5: 0,
      assessment_personal_trainer_id: null,
      fields5: [
        {
          key: "trx_id",
          label: "TRX ID",
          sortable: false
        },
        {
          key: "name",
          label: "Name",
          sortable: false
        },
        // {
        //   key: 'member_pt_session_type.name',
        //   label: 'PT Session Type',
        //   sortable: false
        // },
        {
          key: "pt_session",
          label: "PT Session",
          formatter: (value, key, item) => {
            return (
              item.current_session_qty +
              " of " +
              item.buy_session_qty +
              " Sessions"
            );
          },
          sortable: false
        },
        {
          key: "personal_training.name",
          label: "PT Name",
          sortable: false
        },
        {
          key: "created_at",
          label: "Transaction Date",
          formatter: (value, key, item) => {
            return moment(item.created_at).format("DD MMMM YYYY");
          },
          sortable: false
        },
        {
          key: "expired_at",
          label: "Expired Date",
          formatter: (value, key, item) => {
            return moment(item.expired_at).format("DD MMMM YYYY");
          },
          sortable: false
        },
        {
          key: "status_session",
          label: "Status",
          formatter: (value, key, item) => {
            return item.is_active == 0
              ? "Waiting"
              : item.is_active == 1
                ? "Active"
                : item.is_active == 2
                  ? "Expired"
                  : "";
          },
          sortable: false
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      fields: [
        {
          key: 'leads_activities_type.name',
          label: 'Activity Type',
          sortable: true
        },
        {
          key: 'leads_activities_status.name',
          label: 'Status',
          sortable: true
        },
        {
          key: 'activities_status',
          label: 'Appointment Status',
          sortable: true
        },
        {
          key: 'due_date',
          label: 'Agenda',
          sortable: true
        },
        {
          key: 'start_time',
          label: 'Activity Time',
          sortable: true
        },
        {
          key: 'sales_owner.fullname',
          label: 'Activity Owner',
          sortable: true
        },
        {
          key: 'updated_at',
          label: 'Modified Owner',
          sortable: true
        },
        {
          key: 'notes',
          label: 'Notes',
          sortable: true
        }
        // {
        //   key: 'action',
        //   label: 'Action',
        //   sortable: true
        // }
      ],
      fieldsFirstAssessment: [
        {
          key: 'member',
          label: 'Member Name',
          sortable: true,
          formatter: (value, key, item) => {
            return item.member.first_name + ' ' + item.member.last_name;
          }
        },
        {
          key: 'personal_training.name',
          label: 'Personal Trainer',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Date',
          sortable: true,
          formatter: (value, key, item) => {
            return moment(item.created_at).format('DD MMMM YYYY');
          }
        },
        {
          key: 'action',
          label: 'Action',
          sortable: true
        }
      ],
      itemFirstAssessment: [],
      firstAssessmentCurrentPage: 1,
      firstAssessmentPaginationLimit: 10,
      firstAssessmentTotalPage: 0,
      weekly_log_personal_trainer_id: null,
      fieldsWeeklyLogAssessment: [
        {
          key: 'member',
          label: 'Member Name',
          sortable: true,
          formatter: (value, key, item) => {
            return item.member.first_name + ' ' + item.member.last_name;
          }
        },
        {
          key: 'personal_training.name',
          label: 'Personal Trainer',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Date',
          sortable: true,
          formatter: (value, key, item) => {
            return moment(item.created_at).format('DD MMMM YYYY');
          }
        },
        {
          key: 'action',
          label: 'Action',
          sortable: true
        }
      ],
      itemWeeklyLogAssessment: [],
      weeklyLogAssessmentCurrentPage: 1,
      weeklyLogAssessmentPaginationLimit: 10,
      weeklyLogAssessmentTotalPage: 0,
      twoto4weekchecking_personal_trainer_id: null,
      fieldsTwoto4weekcheckingAssessment: [
        {
          key: 'member',
          label: 'Member Name',
          sortable: true,
          formatter: (value, key, item) => {
            return item.member.first_name + ' ' + item.member.last_name;
          }
        },
        {
          key: 'personal_training.name',
          label: 'Personal Trainer',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Date',
          sortable: true,
          formatter: (value, key, item) => {
            return moment(item.created_at).format('DD MMMM YYYY');
          }
        },
        {
          key: 'action',
          label: 'Action',
          sortable: true
        }
      ],
      itemTwoto4weekcheckingAssessment: [],
      twoto4weekcheckingAssessmentCurrentPage: 1,
      twoto4weekcheckingAssessmentPaginationLimit: 10,
      twoto4weekcheckingAssessmentTotalPage: 0,
      dateTodayData: moment(new Date()).format('YYYY-MM-DD'),
      duplicateSeletedRow: {},
      statusDownload: false,
      salesName: '',
      items: [],
      dataMember: [],
      dataLeads: [],
      dataPha: [],
      dataPT: [],
      phaFields: [
        { key: 'created_at', label: 'Date' },
        { key: 'step1_total_score', label: 'Step 1' },
        { key: 'step2_total_score', label: 'Step 2' },
        { key: 'step3_total_score', label: 'Step 3' },
        { key: 'step4_total_score', label: 'Step 4' },
        { key: 'total_score' },
        { key: 'overall_score' },
        { key: 'action' }
      ],
      fieldDiary: [
        {
          key: 'schedule_date',
          label: 'Date',
          formatter: (value, key, item) => {
            return moment(item.schedule_date).format('DD MMMM YYYY')
          },
          sortable: true
        },
        {
          key: 'action',
          label: 'Action'
        },
      ],
      member_pha_buy_session_qty: '',
      member_pha_current_session_qty: '',
      member_pha_expired_at: '',
      user_role_id: '',
      id_lead: '',
      id_lead_member: '',
      itemMemberDiary: [],
      totalMemberDiary: 0,
      isLoadingMemberDiary: false,
      currentPageMemberDiary: 1,
      paginationLimitMemberDiary: 10,
      phaCurrentPage: 1,
      phaPaginationLimit: 10,
      phaTotalPage: 0,
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      currentPage2: 1,
      paginationLimit2: 10,
      totalPage2: 0,
      itemDownloadPHA: {
        pha_id: ''
      },
      addCall: {
        leads_id: "",
        subject: "",
        notes: "",
        leads_activity_type_id: null,
        leads_activity_status_id: null,
        leads_source_type_id: "1",
        due_date: moment(new Date()).format("YYYY-MM-DD"),
        start_time: "07:00"
      },
      editCall: {
        leads_id: "",
        subject: "",
        leads_activity_type_id: null,
        leads_activity_status_id: null,
        leads_source_type_id: "1",
        due_date: "",
        start_time: ""
      },
      addAppointment: {
        leads_id: "",
        subject: "",
        leads_activity_type_id: "4",
        leads_activity_status_id: null,
        leads_source_type_id: "1",
        due_date: moment(new Date()).format("YYYY-MM-DD"),
        start_time: "07:00",
        appointment_status: null,
        appointment_show_status: null,
        appointment_missed_guest_status: null
      },
      editAppointment: {
        leads_id: "",
        subject: "",
        leads_activity_type_id: "4",
        leads_activity_status_id: null,
        leads_source_type_id: "1",
        due_date: "",
        start_time: "",
        appointment_status: null,
        appointment_show_status: null,
        appointment_missed_guest_status: null
      },
      validateInterested: "",
      data1: [],
      data2: [],
      data3: [],
      config: {},
      config2: {
        enableTime: true,
        noCalendar: true,
        defaultDate: "00:00",
        static: true,
        time_24hr: true
      },
      fields6: [
        {
          key: "created_at",
          label: "Edit Time",
          sortable: true
        },
        {
          key: "notes",
          label: "Notes",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          sortable: false
        }
      ],
      items6: [],
      sortType6: "",
      sortBy6: "",
      searchData6: "",
      currentPage6: 1,
      paginationLimit6: 10,
      totalPage6: 0,
      editNotesData: {
        notes: "",
        created_at: ""
      },
      configDate: {
        altInput: true,
        altFormat: "j F Y H:i",
        dateFormat: "Y-m-d H:i",
        enableTime: true,
        enableSeconds: true,
        static: true,
        time_24hr: true
      },
    }
  },
  methods: {
    pageGymChanged(pageNum) {
      this.currentPageGym = pageNum;
      this.fetchData();
    },
    sortingChangedGym(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    sortingChanged3(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy3 = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType3 = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType3 = "desc";
        // console.log(this.sortType)
      }
      this.fetchData();
    },
    permissionActionNotes() {
      const users = [1071841, 1071846, 511, 1, 1071844]

      if (users.includes(Number(Auth.Session.get().paradigm_id))) {
        return true
      } else {
        return false
      }
    },
    pageOneChanged3(pageNum) {
      this.currentPage3 = pageNum;
      axios
        .get(
          "fitness/v1/history/booking_history?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage3 +
          "&limit=" +
          this.paginationLimit3 +
          "&sorting=" +
          this.sortBy3 +
          "&sorting_type=" +
          this.sortType3 +
          "&keyword=" +
          this.searchData3
        )
        .then(response => {
          this.items3 = response.data.data.rows;
          this.totalPage3 = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    sortingChanged6(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy6 = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType6 = "asc";
        // console.log(this.sortType)
      } else {
        this.sortType6 = "desc";
        // console.log(this.sortType)
      }
      axios
        .get(
          "fitness/v1/member_notes/" +
          this.$route.query.id +
          "&page=" +
          this.currentPage6 +
          "&limit=" +
          this.paginationLimit6 +
          "&sorting=" +
          this.sortBy6 +
          "&sorting_type=" +
          this.sortType6 +
          "&keyword=" +
          this.searchData6 +
          "&v=" +
          new Date().getTime()
        )
        .then(response => {
          this.items6 = response.data.data.rows;
          this.totalPage6 = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    onSubmitFirstAssessment(event) {
      if (this.assessment_personal_trainer_id == null) {
        // show alert
        this.$toast.error("Please select personal trainer", "Error", {
          position: "topCenter",
          timeout: 5000
        });
        return
      }

      const payload = {
        personal_trainer_id: this.assessment_personal_trainer_id,
        member_id: Number(this.id_lead_member),
        leads_id: Number(this.id_lead),
      }

      console.log(payload)
      this.loadingActive = true
      axios.post('crm/v1/assessment/first_assessment', payload).then(response => {
        this.loadingActive = false
        this.hideModal('add-assessment')
        this.$toast.success("data saved successfully!", "Success", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });

        this.$router.push('/memberData/addFirstAssessment?id=' + payload.member_id + '&id_lead=' + payload.leads_id + '&xid=' + response.data.data.create_id);
      }).catch(error => {
        this.loadingActive = false
        this.$toast.error("cant saved data!", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
      })
    },
    onSubmitWeeklyLogAssessement(event) {
      if (this.weekly_log_personal_trainer_id == null) {
        // show alert
        this.$toast.error("Please select personal trainer", "Error", {
          position: "topCenter",
          timeout: 5000
        });
        return
      }

      const payload = {
        personal_trainer_id: this.weekly_log_personal_trainer_id,
        member_id: Number(this.id_lead_member),
        leads_id: Number(this.id_lead),
      }

      console.log(payload)
      this.loadingActive = true
      axios.post('crm/v1/assessment/weekly_log', payload).then(response => {
        this.loadingActive = false
        this.hideModal('add-weekly-log')
        this.$toast.success("data saved successfully!", "Success", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });

        this.$router.push('/memberData/addWeeklyLogAssessment?id=' + payload.member_id + '&id_lead=' + payload.leads_id + '&xid=' + response.data.data.create_id);
      }).catch(error => {
        this.loadingActive = false
        this.$toast.error("cant saved data!", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
      })
    },
    onSubmitTwoFourCheckingAssessement(event) {
      console.log(event)
      if (this.twoto4weekchecking_personal_trainer_id == null) {
        // show alert
        this.$toast.error("Please select personal trainer", "Error", {
          position: "topCenter",
          timeout: 5000
        });
        return
      }

      const payload = {
        personal_trainer_id: this.twoto4weekchecking_personal_trainer_id,
        member_id: Number(this.id_lead_member),
        leads_id: Number(this.id_lead),
      }

      console.log(payload)
      this.loadingActive = true
      axios.post('crm/v1/assessment/2to4weekschecking', payload).then(response => {
        this.loadingActive = false
        this.hideModal('add-checking')
        this.$toast.success("data saved successfully!", "Success", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });

        this.$router.push('/memberData/add2to4weeksChecking?id=' + payload.member_id + '&id_lead=' + payload.leads_id + '&xid=' + response.data.data.create_id);
      }).catch(error => {
        this.loadingActive = false
        this.$toast.error("cant saved data!", "Error", {
          position: "topCenter",
          icon: "icon-envelope",
          progressBarColor: "rgb(0, 255, 184)",
          theme: "dark",
          backgroundColor: "#565c70",
          messageColor: "#fff"
        });
      })
    },
    activeSpinner(value1, value2, value3) {
      this.$refs[value1].disabled = true;
      this.$refs[value1].classList.add("custom-disabled");
      this.$refs[value2].classList.add("hidden");
      this.$refs[value3].classList.remove("hidden");
    },
    disableSpinner(value1, value2, value3) {
      this.$refs[value1].disabled = false;
      this.$refs[value1].classList.remove("custom-disabled");
      this.$refs[value2].classList.remove("hidden");
      this.$refs[value3].classList.add("hidden");
    },
    validateCall(scope) {
      this.activeSpinner("newCall", "submitNewCall", "spinnerNewCall");
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.addCall.leads_id = this.id_lead;
          axios
            .post("crm/v1/leads_activities/", this.addCall, {
              headers: { "X-User-Id": Auth.Session.get().paradigm_user_id }
            })
            .then(response => {
              // console.log('test', response)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.hideModal("new-call");
              this.fetchData();
              this.addCall.leads_id = "";
              this.addCall.notes = "";
              this.addCall.leads_activity_type_id = null;
              this.addCall.leads_activity_status_id = null;
              this.addCall.leads_source_type_id = "1";
              this.addCall.due_date = moment(new Date()).format("YYYY-MM-DD");
              this.addCall.start_time = "07:00";
              this.disableSpinner("newCall", "submitNewCall", "spinnerNewCall");
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.disableSpinner("newCall", "submitNewCall", "spinnerNewCall");
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          this.disableSpinner("newCall", "submitNewCall", "spinnerNewCall");
        }
      });
    },
    validateCallEdit(scope) {
      this.activeSpinner("editCall", "submitEditCall", "spinnerEditCall");
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.editCall.leads_id = this.id_lead;
          axios
            .put("crm/v1/leads_activities/" + this.getActivityId, this.editCall)
            .then(response => {
              // console.log('test', response)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.hideModal("edit-call");
              this.fetchData();
              this.disableSpinner(
                "editCall",
                "submitEditCall",
                "spinnerEditCall"
              );
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.disableSpinner(
                "editCall",
                "submitEditCall",
                "spinnerEditCall"
              );
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          this.disableSpinner("editCall", "submitEditCall", "spinnerEditCall");
        }
      });
    },
    validateAppointment(scope) {
      this.activeSpinner(
        "newAppointment",
        "submitNewAppointment",
        "spinnerNewAppointment"
      );
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.addAppointment.leads_id = this.id_lead;
          axios
            .post("crm/v1/leads_activities/", this.addAppointment, {
              headers: { "X-User-Id": Auth.Session.get().paradigm_user_id }
            })
            .then(response => {
              // console.log('test', response)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.hideModal("new-appointment");
              this.fetchData();
              this.disableSpinner(
                "newAppointment",
                "submitNewAppointment",
                "spinnerNewAppointment"
              );
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.disableSpinner(
                "newAppointment",
                "submitNewAppointment",
                "spinnerNewAppointment"
              );
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          this.disableSpinner(
            "newAppointment",
            "submitNewAppointment",
            "spinnerNewAppointment"
          );
        }
      });
    },
    validateAppointmentEdit(scope) {
      this.activeSpinner(
        "editAppointment",
        "submitEditAppointment",
        "spinnerEditAppointment"
      );
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.editAppointment.leads_id = this.id_lead;
          if (this.editAppointment.appointment_status === "notShow") {
            this.editAppointment.appointment_show_status = null;
            this.editAppointment.appointment_missed_guest_status = null;
          }
          if (this.editAppointment.appointment_show_status === "member") {
            this.editAppointment.appointment_missed_guest_status = null;
          }
          axios
            .put(
              "crm/v1/leads_activities/" + this.getActivityId,
              this.editAppointment
            )
            .then(response => {
              // console.log('test', response)
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.hideModal("edit-appointment");
              this.fetchData();
              this.disableSpinner(
                "editAppointment",
                "submitEditAppointment",
                "spinnerEditAppointment"
              );
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
              this.disableSpinner(
                "editAppointment",
                "submitEditAppointment",
                "spinnerEditAppointment"
              );
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
          this.disableSpinner(
            "editAppointment",
            "submitEditAppointment",
            "spinnerEditAppointment"
          );
        }
      });
    },
    pageOneChanged5(pageNum) {
      this.currentPage5 = pageNum;
      this.fetchData();
    },
    enterClicked(searchEvent) {
      this.fetchData();
    },
    sortingChanged5(event) {
      this.sortBy5 = event.sortBy;
      if (event.sortDesc === false) {
        this.sortType5 = "asc";
      } else {
        this.sortType5 = "desc";
      }
      this.fetchData();
    },
    changeDate(event) {
      console.log(event)
    },
    showModalDuplicate(id, data) {
      console.log(data)
      this.duplicateSeletedRow = data
      // console.log(id)
      this.$refs[id].show()
    },
    async deleteMemberDiary(data) {
      // console.log(data)
      let isConfirm = await this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
        showLoaderOnConfirm: false
      })

      if (isConfirm.value) {
        axios.delete('crm/v1/member_pt_diary/all/' + data.member_id + '/' + data.schedule_date).then(response => {
          console.log(response)
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          this.fetchData()
        }).catch(error => {
          console.log('error', error)
        })
      } else {
        this.$swal('Cancelled', 'Your transaction cancelled', 'info')
      }
    },
    async dupicateMemberDiary(data) {

      let isConfirm = await this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: true,
        showLoaderOnConfirm: false
      })

      // get member diary
      axios.get('crm/v1/member_pt_diary?member=' + this.id_lead_member + '&scheduledate=' + data.schedule_date).then(response => {
        console.log(response)
        let rows = response.data.data.rows

        if (isConfirm.value) {
          this.$refs['modalChangePass'].hide()
          if (response) {
            for (let i = 0; i < rows.length; i++) {
              const _new_data = {
                dist: rows[i].dist,
                how_many_movement: rows[i].how_many_movement,
                intensity: rows[i].intensity,
                member_category: rows[i].member_pt_diary_category_id == null ? null : rows[i].member_pt_diary_category_id,
                member_id: rows[i].member_id,
                member_pt_diary_activity_id: rows[i].member_pt_diary_activity_id == null ? null : rows[i].member_pt_diary_activity_id,
                member_subcategory: rows[i].member_pt_diary_subcategory_id == null ? null : rows[i].member_pt_diary_subcategory_id,
                number_of_session: rows[i].number_of_session,
                one_rm: rows[i].one_rm,
                personal_trainer_id: rows[i].personal_trainer_id,
                reps: rows[i].reps,
                schedule_date: this.dateTodayData,
                sets: rows[i].sets,
                time: rows[i].time,
                weight: rows[i].weight,
                notes: rows[i].notes
              }

              axios.post("crm/v1/member_pt_diary", _new_data).then(response => {
                this.$toast.success("Successfully!", "Success", {
                  position: "topCenter",
                  icon: "icon-envelope",
                  progressBarColor: "rgb(0, 255, 184)",
                  theme: "dark",
                  backgroundColor: "#565c70",
                  messageColor: "#fff"
                });
              })
                .catch(error => {
                  console.log("error", error.response);
                  // console.log('error', error.response.data.error)
                  if (error.response.data) {
                    this.$toast.success(error.response.data.error, "Error", {
                      position: "topCenter",
                      icon: "icon-envelope",
                      progressBarColor: "rgb(0, 255, 184)",
                      theme: "dark",
                      backgroundColor: "#565c70",
                      messageColor: "#fff"
                    });
                  } else {
                    this.$toast.success("Cant saved data!", "Error", {
                      position: "topCenter",
                      icon: "icon-envelope",
                      progressBarColor: "rgb(0, 255, 184)",
                      theme: "dark",
                      backgroundColor: "#565c70",
                      messageColor: "#fff"
                    });
                  }
                });

            }
          }
          setTimeout(() => {
            window.location.reload()
          }, 1000);
        } else {
          this.$swal('Cancelled', 'Your transaction cancelled', 'info')
        }
      }).catch(error => {
        window.location.reload()
        console.log('error', error)
      })


    },
    loadingView() {
      this.loadingActive = false
    },
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    pageOneChanged6(pageNum) {
      this.currentPage6 = pageNum;
      this.fetchData();
    },
    pageMemberDiayChanged(pageNum) {
      this.isLoadingMemberDiary = true
      this.currentPageMemberDiary = pageNum
      axios.get('crm/v1/member_pt_diary?member=' + this.$route.query.id + '&page=' + this.currentPageMemberDiary + '&limit=' + this.paginationLimit + '&groupby_scheduledate=yes').then(response => {
        this.isLoadingMemberDiary = false
        this.itemMemberDiary = response.data.data.rows
        this.totalMemberDiary = response.data.meta.pageCount
      }).catch(error => {
        this.isLoadingMemberDiary = false
        console.log('error', error)
      })
    },
    pageWeeklyLogAssessmentChanged(pageNum) {
      this.weeklyLogAssessmentCurrentPage = pageNum
      this.fetchWeeklyLogAssessment()
    },
    pageTwoToFourCheckingAssessmentChanged(pageNum) {
      this.twoto4weekcheckingAssessmentCurrentPage = pageNum
      this.fetchTwoto4WeekAssessment()
    },
    pageFirstAssessmentChanged(pageNum) {
      this.firstAssessmentCurrentPage = pageNum
      this.fetchFirstAssessment()
    },
    pageOneChanged2(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    phaPageOneChanged(pageNum) {
      this.phaCurrentPage = pageNum
      this.fetchPhaData()
    },
    sortingChanged(event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    getRowCount(items) {
      return items.length
    },
    getBadge(status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    downloadPHA(event, date) {
      // this.statusDownload = true
      // console.log(this.$refs['download' + event].getAttribute('name'))
      if ('download' + event === this.$refs['download' + event].getAttribute('name')) {
        this.$refs['download' + event].disabled = true
        this.$refs['download' + event].classList.add("custom-disabled")
        this.$refs['iconDownload' + event].classList.add("hidden")
        this.$refs['spinnerDownload' + event].classList.remove("hidden")
      }
      this.itemDownloadPHA.pha_id = event
      axios({
        url: 'crm/v1/member_pha/pdf_download/',
        method: 'POST',
        responseType: 'blob',
        data: this.itemDownloadPHA
      }).then(response => {
        var elementDownload = document.getElementById('downloadAnchorElem')
        var data = new Blob([response.data])
        var url = window.URL.createObjectURL(data)
        elementDownload.setAttribute('download', 'PHA_' + this.dataMember.first_name.replace(' ', '_') + '_' + this.dataMember.last_name.replace(' ', '_') + '(' + this.parseDate(date) + ').pdf')
        elementDownload.href = url
        elementDownload.click()
        if (response) {
          this.$refs['download' + event].disabled = false
          this.$refs['download' + event].classList.remove("custom-disabled")
          this.$refs['iconDownload' + event].classList.remove("hidden")
          this.$refs['spinnerDownload' + event].classList.add("hidden")
          // this.statusDownload = false
        }
        // console.log('response download', response)
      }).catch(error => {
        console.log('error', error)
      })
    },
    openPage(event) {
      this.$router.push(event)
    },
    showModal(id) {
      this.$refs[id].show()
    },
    editCallModal(id, event) {
      this.$refs[id].show()
      this.getActivityId = event
      // console.log(event)
      axios.get('crm/v1/leads_activities/' + event).then(response => {
        this.editCall = response.data.data
        // this.statusActivityCall(2)
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    deleteFirstAssessment(id) {
      console.log(id)
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, save it!",
        })
        .then((result) => {
          if (result.value) {
            this.loadingActive = true
            axios.delete('crm/v1/assessment/first_assessment/' + id).then(response => {
              this.loadingActive = false
              console.log(response)
              this.$swal.fire(
                "Deleted!",
                "Data has been deleted.",
                "success"
              );
              this.fetchFirstAssessment()
            }).catch(error => {
              this.loadingActive = false
              console.log('error', error)
            })
          }
        });
    },
    deleteWeeklyLogAssessment(id) {
      console.log(id)
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, save it!",
        })
        .then((result) => {
          if (result.value) {
            this.loadingActive = true
            axios.delete('crm/v1/assessment/weekly_log/' + id).then(response => {
              this.loadingActive = false
              console.log(response)
              this.$swal.fire(
                "Deleted!",
                "Data has been deleted.",
                "success"
              );
              this.fetchWeeklyLogAssessment()
            }).catch(error => {
              this.loadingActive = false
              console.log('error', error)
            })
          }
        });
    },
    delete2to4WeekCheckingAssessment(id) {
      console.log(id)
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, save it!",
        })
        .then((result) => {
          if (result.value) {
            this.loadingActive = true
            axios.delete('crm/v1/assessment/2to4weekschecking/' + id).then(response => {
              this.loadingActive = false
              console.log(response)
              this.$swal.fire(
                "Deleted!",
                "Data has been deleted.",
                "success"
              );
              this.fetchWeeklyLogAssessment()
            }).catch(error => {
              this.loadingActive = false
              console.log('error', error)
            })
          }
        });
    },
    editAppointmentModal(id, event) {
      this.$refs[id].show()
      this.getActivityId = event
      // console.log(event)
      axios.get('crm/v1/leads_activities/' + event).then(response => {
        this.editAppointment = response.data.data
        // this.statusActivityAppointment(4)
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    hideModal(id) {
      this.$refs[id].hide()
    },
    todayNumber() {
      return moment().isoWeekday()
    },
    cutTime(value) {
      return (value).slice(0, -3)
    },
    getNumberDay(value) {
      return moment(new Date(value)).isoWeekday()
    },
    parseDate(value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD-MM-YY')
    },
    parseDateTime(value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD MMMM YYYY')
    },
    parseDateTime1(value) {
      moment.locale('en')
      return moment(new Date(value)).format('DD')
    },
    parseDateTime2(value) {
      moment.locale('en')
      return moment(new Date(value)).format('dddd')
    },
    parseDateTime3(value) {
      var curr = new Date
      var first = curr.getDate() - curr.getDay()
      var monthName = new Date(curr.getTime())
      moment.locale('en')
      return moment(new Date(monthName)).format('MMMM YYYY')
    },
    parseImg(value) {
      if (value) {
        return Auth.apiUrl + 'crm/v1/img/leads/' + value
      }
    },
    phaForm() {

    },
    fetchFirstAssessment() {
      axios.get(`crm/v1/assessment/first_assessment?member_id=${this.id_lead_member}&leads_id=${this.id_lead}&page=${this.firstAssessmentCurrentPage}&limit=${this.firstAssessmentPaginationLimit}`).then(response => {
        this.itemFirstAssessment = response.data.data.rows
        this.firstAssessmentTotalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchWeeklyLogAssessment() {
      axios.get(`crm/v1/assessment/weekly_log?member_id=${this.id_lead_member}&leads_id=${this.id_lead}&page=${this.firstAssessmentCurrentPage}&limit=${this.firstAssessmentPaginationLimit}`).then(response => {
        this.itemWeeklyLogAssessment = response.data.data.rows
        this.weeklyLogAssessmentTotalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchTwoto4WeekAssessment() {
      axios.get(`crm/v1/assessment/2to4weekschecking?member_id=${this.id_lead_member}&leads_id=${this.id_lead}&page=${this.firstAssessmentCurrentPage}&limit=${this.firstAssessmentPaginationLimit}`).then(response => {
        this.itemTwoto4weekcheckingAssessment = response.data.data.rows
        this.twoto4weekcheckingAssessmentTotalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      if (this.$route.query.id_lead) {
        axios.get('crm/v1/leads/' + this.$route.query.id_lead).then(response => {
          this.dataLeads = response.data.data
        }).catch(error => {
          console.log('error', error)
        })
      }

      axios
        .get(
          "fitness/v1/history/booking_history?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage3 +
          "&limit=" +
          this.paginationLimit3 +
          "&sorting=" +
          this.sortBy3 +
          "&sorting_type=" +
          this.sortType3 +
          "&keyword=" +
          this.searchData3
        )
        .then(response => {
          this.items3 = response.data.data.rows;
          this.totalPage3 = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });

        axios
        .get(
          "fitness/v1/history/gym_attendance?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPageGym +
          "&limit=" +
          this.paginationLimit +
          "&sorting=" +
          this.sortByGym +
          "&sorting_type=" +
          this.sortTypeGym +
          "&keyword=" +
          this.searchDataGym
        )
        .then(response => {
          this.itemsGym = response.data.data.rows;
          this.totalPageGym = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });

      // if(Auth.Session.get().paradigm_role === '7' || Auth.Session.get().paradigm_role === '9') {
      //   axios.get('fitness/v1/personal_training/my_member?pt_id=' + Auth.Session.get().paradigm_id).then(response => {
      //     console.log('response first',response.data.data.rows)
      //     var data = response.data.data.rows
      //     var itemsMemberPha = data.filter(item => item.id == parseInt(this.$route.query.id))
      //     this.member_pha_buy_session_qty = itemsMemberPha[0].member_pt_sessions ? itemsMemberPha[0].member_pt_sessions[0].buy_session_qty : '-'
      //     this.member_pha_current_session_qty = itemsMemberPha[0].member_pt_sessions ? itemsMemberPha[0].member_pt_sessions[0].current_session_qty : '-'
      //     this.member_pha_expired_at = itemsMemberPha[0].member_pt_sessions ? itemsMemberPha[0].member_pt_sessions[0].expired_at : '-'
      //     // console.log('response', itemsMemberPha)
      //   }).catch(error => {
      //     console.log('error', error)
      //   })
      // }
      // LEADS CALL
      axios
        .get("crm/v1/leads_activities_type?status=active")
        .then(response => {
          this.data1 = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/leads_activities_status?leads_activities_type_id=2")
        .then(response => {
          this.data2 = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("crm/v1/leads_activities_status?leads_activities_type_id=4")
        .then(response => {
          this.data3 = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      // END LEADS CALL

      axios.get('fitness/v1/member/' + this.$route.query.id).then(response => {
        this.dataMember = response.data.data
        // console.log('list data', this.dataMember)
        this.salesName = response.data.data.sales.fullname
        if (Auth.Session.get().paradigm_id == 15101924) {
          this.dataMember.sales_id = this.dataLeads.owner_id
        }
        axios.get('crm/v1/leads_activities?is_from_sales_page=true&sales_id=' + this.dataMember.sales_id + '&leads_id=' + this.$route.query.id_lead + '&page=' + this.currentPage2 + '&limit=' + this.paginationLimit2).then(response => {
          this.items = response.data.data.rows
          for (var i = 0; i < this.items.length; i++) {
            // console.log()
            if (this.items[i].leads_activities_status.name == "Interested") {
              this.validateInterested = "Interested";
              break;
            }
          }
          this.totalPage2 = response.data.meta.pageCount
          console.log('test', response.data.data)
        }).catch(error => {
          console.log('error', error)
        })
        // console.log('print', this.getDocType)
        //console.log('test', this.dataMember)
      }).catch(error => {
        console.log('error', error)
      })
      axios.get('crm/v1/member_pt_diary?member=' + this.$route.query.id + '&page=' + this.currentPageMemberDiary + '&limit=' + this.paginationLimit + '&groupby_scheduledate=yes').then(response => {
        this.itemMemberDiary = response.data.data.rows
        this.totalMemberDiary = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })

      // GET member pt session
      axios
        .get(
          "fitness/v1/member_pt_session?member_id=" +
          this.$route.query.id +
          "&page=" +
          this.currentPage5 +
          "&limit=" +
          this.paginationLimit5 +
          "&sorting=" +
          this.sortBy5 +
          "&sorting_type=" +
          this.sortType5 +
          "&keyword=" +
          this.searchData5 +
          "&v=" +
          new Date()
        )
        .then(response => {
          this.items5 = response.data.data.rows;
          this.totalPage5 = response.data.meta.pageCount;
        })
        .catch(error => {
          console.log("error", error);
        });

      // Notes History
      axios
        .get(
          "fitness/v1/member_notes/" +
          this.$route.query.id +
          "&page=" +
          this.currentPage6 +
          "&limit=" +
          this.paginationLimit6 +
          "&sorting=" +
          this.sortBy6 +
          "&sorting_type=" +
          this.sortType6 +
          "&keyword=" +
          this.searchData6 +
          "&v=" +
          new Date().getTime()
        )
        .then(response => {
          this.items6 = response.data.data.rows;
          this.totalPage6 = response.data.meta.pageCount;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });

      axios
        .get("fitness/v1/personal_training")
        .then((response) => {
          this.dataPT = response.data.data.rows;

          if (Auth.Session.get().paradigm_role == 7) {
            this.dataPT = this.dataPT.filter(item => item.id == Auth.Session.get().paradigm_id)
            // this.addData.personal_trainer_id = Auth.Session.get().paradigm_id
          }
          // console.log('test', response.data.data.rows)
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    fetchPhaData() {
      this.id_lead_member = this.$route.query.id
      this.id_lead = this.$route.query.id_lead
      axios.get('crm/v1/member_pha/' + this.$route.query.id + '?page=' + this.phaCurrentPage + '&limit=' + this.phaPaginationLimit).then(response => {
        this.dataPha = response.data.data.rows
        this.phaTotalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created() {
    this.user_role_id = Auth.Session.get().paradigm_role
    this.fetchData()
    this.fetchPhaData()
    this.fetchFirstAssessment()
    this.fetchWeeklyLogAssessment()
    this.fetchTwoto4WeekAssessment()

    const isclbManager = Auth.Session.get().paradigm_role_mapping_id
    if (isclbManager.includes(17)) {
      this.isViewOnly = true
    }
  }
}
</script>
